module.exports = __webpack_public_path__ + "img/bg-body-left.ae010de7.svg";